import { Pencil } from "lucide-react";

interface QuotationBasicInformationProps {
  quotation: {
    recipient_name: string;
    attention: string;
    email: string;
    quotation_no: string;
    quotation_date: string;
    sales_name: string;
    delivery_time: string;
    place_of_delivery: string;
    payment: string;
    validity: string;
    createdAt: string;
  };
  onEdit: () => void;
  // true: tombol Edit dinonaktifkan (mis. Sales & quotation sudah diproses)
  editDisabled?: boolean;
}

const formatDate = (value: string) =>
  new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" }).format(
    new Date(value)
  );

export default function QuotationBasicInformation({
  quotation,
  onEdit,
  editDisabled = false,
}: QuotationBasicInformationProps) {
  return (
    <div className="rounded-2xl border border-gray-100 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Basic Information</h3>
        <button
          onClick={onEdit}
          disabled={editDisabled}
          title={
            editDisabled
              ? "Quotation sudah diproses (DO/PO/WO) dan tidak dapat diedit"
              : undefined
          }
          className="flex items-center gap-1 rounded-lg bg-blue-100 px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-200 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
        >
          <Pencil size={14} />
          Edit Quotation
        </button>
      </div>

      <div className="grid grid-cols-2 gap-x-10 gap-y-2 text-sm">
        <Row label="To" value={quotation.recipient_name} />
        <Row label="Sales Name" value={quotation.sales_name} />

        <Row label="Attn" value={quotation.attention || "-"} />
        <Row label="Delivery Time" value={quotation.delivery_time || "-"} />

        <Row label="Email" value={quotation.email || "-"} />
        <Row label="Place of Delivery" value={quotation.place_of_delivery || "-"} />

        <Row label="No Quotation" value={quotation.quotation_no} />
        <Row label="Payment" value={quotation.payment || "-"} />

        <Row label="Date" value={formatDate(quotation.quotation_date)} />
        <Row label="Validity" value={quotation.validity || "-"} />
      </div>

      <p className="mt-4 flex items-center gap-1 text-xs text-gray-400">
        Create at {new Date(quotation.createdAt).toLocaleDateString("id-ID")}{" "}
        {new Date(quotation.createdAt).toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        })}{" "}
        WIB
      </p>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex">
      <span className="w-36 shrink-0 text-gray-500">{label}</span>
      <span className="mr-2">:</span>
      <span className="font-medium text-gray-800">{value}</span>
    </div>
  );
}
